import React from 'react'

import Image from '@Pure/Image'
import Logo  from '@Pure/Logo'
import Link  from '@Pure/Link'

import bemit from '@function/bemit'

const { app } = window;

export default function ArticleSlideCard ({ type, article, ...props })
{
	let thumbnail;

	if (article.images?.[0]?.url)
	{
		thumbnail = article.images[0].url;
	}
	else if (article._artist?.images?.[0]?.url)
	{
		thumbnail = article._artist.images[0].url;
	}

	if (thumbnail)
	{
		thumbnail =
		(
			<Image className="c-model-preview__img" src={ thumbnail } />
		);
	}
	else
	{
		thumbnail =
		(
			<Logo className="c-model-preview__img default" type="svg"
				synergies={ true }
			/>
		);
	}

	const title = app.getTruncatedText(article.title, 60).toUpperCase();

	const url = type === 'synergies'
	? '/blog-synergies/' + article.id
	: type === 'ad'
	? '/promotions/' + article.id
	: type === 'legal'
	? '/blog-juridique/' + article.id
	: '/accueil/mon-espace/blog/' + article.id;

	const modifiers = ['home'].concat(props.bemit || []);

	let output =
	(
		<div className={ bemit('c-model-preview-item', ['blog', 'slider', 'home']) }
			key={ article.id }>

			<div className={ bemit('c-model-preview', modifiers) }>

				<div className="c-model-preview__thumb">
					<Link className="c-model-preview__thumb-link"
						href={ url }>
						{ thumbnail }
					</Link>
				</div>

				<div className="c-model-preview__content">

					<h2 className="c-model-preview__title">
						<Link href={ url }
							className="c-model-preview__title-link">
							{ title }
						</Link>
					</h2>

				</div>

			</div>

		</div>
	);

	return output;
}